import { render, staticRenderFns } from "./activeVisits.vue?vue&type=template&id=6e797dd5&"
import script from "./activeVisits.vue?vue&type=script&lang=js&"
export * from "./activeVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports